import { lazy, Suspense } from "react";
import SiteHeader from "@/components/SiteHeader";
import BrandHero from "@/components/home/BrandHero";
import SiloEntryBlocks from "@/components/home/SiloEntryBlocks";
import { useSEO } from "@/hooks/useSEO";
import JsonLd from "@/components/JsonLd";

const FeaturedTransformerCategories = lazy(() => import("@/components/home/FeaturedTransformerCategories"));
const FeaturedAutomationCategories = lazy(() => import("@/components/home/FeaturedAutomationCategories"));
const FeaturedBrands = lazy(() => import("@/components/home/FeaturedBrands"));
const FeaturedManufacturersSilo = lazy(() => import("@/components/home/FeaturedManufacturersSilo"));
const WhyNardySection = lazy(() => import("@/components/home/WhyNardySection"));
const HomeFAQ = lazy(() => import("@/components/home/HomeFAQ"));
const HomeBlogSection = lazy(() => import("@/components/HomeBlogSection"));
const FinalCTA = lazy(() => import("@/components/FinalCTA"));
const SiteFooter = lazy(() => import("@/components/SiteFooter"));

const SITE_URL = "https://nardyautomation.com";

const Index = () => {
  useSEO({
    title: "Nardy Automation — Transformer Parts & Industrial Automation Supplier USA",
    description:
      "Industrial parts supplier for transformers and automation. Bushings, Buchholz relays, PLCs, HMIs, VFDs and more — US inventory with fast worldwide shipping.",
    canonical: "/",
  });

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Nardy Automation",
    url: SITE_URL,
    logo: `${SITE_URL}/favicon.ico`,
    description:
      "Industrial parts supplier for transformer components and industrial automation parts. US inventory, worldwide shipping.",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Windermere",
      addressRegion: "FL",
      addressCountry: "US",
    },
    areaServed: "Worldwide",
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Nardy Automation",
    url: SITE_URL,
    potentialAction: {
      "@type": "SearchAction",
      target: `${SITE_URL}/shop?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <main>
      <JsonLd id="home-organization" data={organizationSchema} />
      <JsonLd id="home-website" data={websiteSchema} />
      <SiteHeader />
      <BrandHero />
      <SiloEntryBlocks />
      <Suspense fallback={<div className="min-h-[200px]" />}>
        <FeaturedTransformerCategories />
        <FeaturedAutomationCategories />
        <FeaturedBrands />
        <FeaturedManufacturersSilo />
        <WhyNardySection />
        <HomeFAQ />
        <HomeBlogSection />
        <FinalCTA />
        <SiteFooter />
      </Suspense>
    </main>
  );
};

export default Index;
